export default __webpack_public_path__ + "static/media/fw-harper-er-Rose Gold.f6713c5a.mp4";